import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { logoutaLL } from '../../../../config';

function AdminProfileMenu({ forpage, isDrawer = 0 }) {
    const [ActiveMenu, setAdminActiveMenu] = useState(localStorage.getItem("AdminActiveMenu") || 'dashboard');
    function setActiveMenu(v) {
        setAdminActiveMenu(v);
        localStorage.setItem("AdminActiveMenu", v);
    } 
    const [MenuUsers, setMenuUsers] = useState(0);
    const [MenuMaster, setMenuMaster] = useState(0);
    const [MenuContent, setMenuContent] = useState(0);
    const [MenuRequest, setMenuRequest] = useState(0);
    const [MenuPages, setMenuPages] = useState(0);
    function toggleMenu(formenu, value) {
        localStorage.setItem("adminForMenu", formenu);
        localStorage.setItem("adminForMenuValue", value);
        setMenuUsers(0);
        setMenuMaster(0);
        setMenuContent(0);
        setMenuRequest(0);
        setMenuPages(0);
        switch (formenu) {
            case 'MenuDashboard':
                break;
            case 'MenuPages':
                setMenuPages(value);
                break;
            case 'MenuRequest':
                setMenuRequest(value);
                break;
            case 'MenuContent':
                setMenuContent(value);
                break;
            case 'MenuMaster':
                setMenuMaster(value);
                break;
            case 'MenuUsers':
            default:
                setMenuUsers(value);
                break;
        }
    }

    function closedrawer() {
        if (isDrawer === 1) {
            const get = document.getElementById('closedrawer');
            get.click();
        }
    }

    useEffect(() => {
        const adminForMenu = localStorage.getItem("adminForMenu");
        const adminForMenuValue = localStorage.getItem("adminForMenuValue");
        toggleMenu(adminForMenu, adminForMenuValue === '1' ? 0 : 1);
    },[])

    return (
        <>
            <div className="ry_instr_shadow pt-3 pb-3 p-3" forpage={forpage}>
                <ul className="offcanvas_main_menu">
                    <li className="">
                        <Link
                            to="/admin-dashboard"
                            onClick={() => {
                                closedrawer();
                                toggleMenu('MenuDashboard', 1);
                                setActiveMenu('admin-dashboard');
                            }}
                            className={ActiveMenu === "admin-dashboard" ? "ry_admin_menu active": "ry_admin_menu"}
                        >
                            <i className="fal fa-star" /> Dashboard
                        </Link>
                    </li>

                    <li className="menu-item-has-children ry_admin_menu">
                        <span className="menu-expand">
                            <i
                                className="fa fa-angle-right"
                                style={{ display: MenuUsers === 1 ? 'none' : 'block' }}
                                onClick={() => {
                                    toggleMenu('MenuUsers', 1);
                                }}
                            ></i>
                            <i
                                className="fa fa-angle-down"
                                style={{ display: MenuUsers === 1 ? 'block' : 'none' }}
                                onClick={() => {
                                    toggleMenu('MenuUsers', 0);
                                }}
                            ></i>
                        </span>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu('MenuUsers', 1);
                            }}
                        >
                            <i className="fal fa-users" /> Users
                        </a>
                        <ul
                            className="sub-menu mt-3"
                            style={{ display: MenuUsers === 1 ? 'block' : 'none' }}
                        >
                            <li>
                                <Link
                                    to="/admin/page/admins-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('admins-manage');
                                    }}
                                    className={ActiveMenu === "admins-manage" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Admin
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/instructors-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('instructors-manage');
                                    }}
                                    className={ActiveMenu === "instructors-manage" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Instructor
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/students-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('students-manage');
                                    }}
                                    className={ActiveMenu === "students-manage" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Students
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/students-videoCourses"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('students-videoCourses');
                                    }}
                                    className={ActiveMenu === "students-videoCourses" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Enrolled Students
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className="menu-item-has-children ry_admin_menu">
                        <span className="menu-expand">
                            <i
                                className="fa fa-angle-right"
                                style={{ display: MenuContent === 1 ? 'none' : 'block' }}
                                onClick={() => {
                                    toggleMenu('MenuContent', 1);
                                }}
                            ></i>
                            <i
                                className="fa fa-angle-down"
                                style={{ display: MenuContent === 1 ? 'block' : 'none' }}
                                onClick={() => {
                                    toggleMenu('MenuContent', 0);
                                }}
                            ></i>
                        </span>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu('MenuContent', 1);
                            }}
                        >
                            <i className="fal fa-users" /> Contents
                        </a>
                        <ul
                            className="sub-menu mt-3"
                            style={{ display: MenuContent === 1 ? 'block' : 'none' }}
                        >
                            <li>
                                <Link
                                    to="/admin/page/maincourse-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('maincourse-manage');
                                    }}
                                    className={ActiveMenu === "maincourse-manage" ? "active": ""}
                                >
                                    <i className="fal fa-books" /> Products
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/myblog"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('myblog-manage');
                                    }}
                                    className={ActiveMenu === "myblog-manage" ? "active": ""}
                                >
                                    <i className="fal fa-folder" /> Blogs
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/orders"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('orders-manage');
                                    }}
                                    className={ActiveMenu === "orders-manage" ? "active": ""}
                                >
                                    <i className="fal fa-file-invoice" /> Orders
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className="menu-item-has-children ry_admin_menu">
                        <span className="menu-expand">
                            <i
                                className="fa fa-angle-right"
                                style={{ display: MenuRequest === 1 ? 'none' : 'block' }}
                                onClick={() => {
                                    toggleMenu('MenuRequest', 1);
                                }}
                            ></i>
                            <i
                                className="fa fa-angle-down"
                                style={{ display: MenuRequest === 1 ? 'block' : 'none' }}
                                onClick={() => {
                                    toggleMenu('MenuRequest', 0);
                                }}
                            ></i>
                        </span>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu('MenuRequest', 1);
                            }}
                        >
                            <i className="fal fa-users" /> Request
                        </a>
                        <ul
                            className="sub-menu mt-3"
                            style={{ display: MenuRequest === 1 ? 'block' : 'none' }}
                        >
                            <li>
                                <Link
                                    to="/admin/page/email-subscribers"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('email-subscribers');
                                    }}
                                    className={ActiveMenu === "email-subscribers" ? "active": ""}
                                >
                                    <i className="fal fa-envelope" /> Email Subscriber
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/request-team"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('request-team');
                                    }}
                                    className={ActiveMenu === "request-team" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Team Request
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/contact-enquiry"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('contact-enquiry');
                                    }}
                                    className={ActiveMenu === "contact-enquiry" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Contact Enquiry
                                </Link>
                            </li>
                             <li>
                                <Link
                                    to="/admin/page/career-enquiry"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('career-enquiry');
                                    }}
                                    className={ActiveMenu === "career-enquiry" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Career Enquiry
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/reported-bugs"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('reported-bugs');
                                    }}
                                    className={ActiveMenu === "reported-bugs" ? "active": ""}
                                >
                                    <i className="fal fa-bug" /> Bug Reported
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className="menu-item-has-children ry_admin_menu">
                        <span className="menu-expand">
                            <i
                                className="fa fa-angle-right"
                                style={{ display: MenuMaster === 1 ? 'none' : 'block' }}
                                onClick={() => {
                                    toggleMenu('MenuMaster', 1);
                                }}
                            ></i>
                            <i
                                className="fa fa-angle-down"
                                style={{ display: MenuMaster === 1 ? 'block' : 'none' }}
                                onClick={() => {
                                    toggleMenu('MenuMaster', 0);
                                }}
                            ></i>
                        </span>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu('MenuMaster', 1);
                            }}
                        >
                            <i className="fal fa-cog" /> Master Settings
                        </a>
                        <ul
                            className="sub-menu mt-3"
                            style={{ display: MenuMaster === 1 ? 'block' : 'none' }}
                        >
                            <li>
                                <Link
                                    to="/admin/page/manage-topmessage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('manage-topmessage');
                                    }}
                                    className={ActiveMenu === "manage-topmessage" ? "active": ""} 
                                >
                                    <i className="fal fa-image" /> Top Message
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/homeslider-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('homeslider-manage');
                                    }}
                                    className={ActiveMenu === "homeslider-manage" ? "active": ""}
                                >
                                    <i className="fal fa-image" /> Manage Slider
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/categories-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('categories-manage');
                                    }}
                                    className={ActiveMenu === "categories-manage" ? "active": ""}
                                >
                                    <i className="fal fa-file" /> Products Categories
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/blogcategories-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('blogcategories-manage');
                                    }}
                                    className={ActiveMenu === "blogcategories-manage" ? "active": ""}
                                >
                                    <i className="fal fa-file" /> Blog Categories
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/testimonials-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('testimonials-manage');
                                    }}
                                    className={ActiveMenu === "testimonials-manage" ? "active": ""}
                                >
                                    <i className="fal fa-users" /> Testimonials
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/faqs-manage"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('faqs-manage');
                                    }}
                                    className={ActiveMenu === "faqs-manage" ? "active": ""}
                                >
                                    <i className="fal fa-image" /> FAQs
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className="menu-item-has-children ry_admin_menu">
                        <span className="menu-expand">
                            <i
                                className="fa fa-angle-right"
                                style={{ display: MenuPages === 1 ? 'none' : 'block' }}
                                onClick={() => {
                                    toggleMenu('MenuPages', 1);
                                }}
                            ></i>
                            <i
                                className="fa fa-angle-down"
                                style={{ display: MenuPages === 1 ? 'block' : 'none' }}
                                onClick={() => {
                                    toggleMenu('MenuPages', 0);
                                }}
                            ></i>
                        </span>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                toggleMenu('MenuPages', 1);
                            }}
                        >
                            <i className="fal fa-folder" /> Pages Settings
                        </a>
                        <ul
                            className="sub-menu mt-3"
                            style={{ display: MenuPages === 1 ? 'block' : 'none' }}
                        >
                            {/* <li
                                onClick={() => {
                                    closedrawer();
                                }}
                            >
                                <Link to="/admin/page/category-seo-settings">
                                    <i className="fal fa-file" /> Category Seo Settings
                                </Link>
                            </li>
                            <li
                                onClick={() => {
                                    closedrawer();
                                }}
                            >
                                <Link to="/admin/page/courses-seo-settings">
                                    <i className="fal fa-file" /> Course Seo Settings
                                </Link>
                            </li> */}
                            {/* <li
                                onClick={() => {
                                    closedrawer();
                                }}
                            >
                                <Link to="/admin/page/seo-settings">
                                    <i className="fal fa-file" /> Seo Settings
                                </Link>
                            </li> */}
                            <li>
                                <Link
                                    to="/admin/page/set-certifications"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('set-certifications');
                                    }}
                                    className={ActiveMenu === "set-certifications" ? "active": ""}
                                >
                                    <i className="fal fa-file" /> Certifications
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/set-term"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('set-term');
                                    }}
                                    className={ActiveMenu === "set-term" ? "active": ""}
                                >
                                    <i className="fal fa-file" /> Terms and Conditions
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/set-privacy"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('set-privacy');
                                    }}
                                    className={ActiveMenu === "set-privacy" ? "active": ""}
                                >
                                    <i className="fal fa-file" /> Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin/page/set-RefundAndCancellation"
                                    onClick={() => {
                                        closedrawer();
                                        setActiveMenu('set-RefundAndCancellation');
                                    }}
                                    className={ActiveMenu === "set-RefundAndCancellation" ? "active": ""}
                                >
                                    <i className="fal fa-file" /> Refund and Cancellation
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li className="">
                        <Link
                            to="/admin-dashboard"
                            className="ry_admin_menu"
                            onClick={() => {
                                logoutaLL('admin');
                            }}
                        >
                            <i className="fal text-danger fa-sign-out" /> Logout
                        </Link>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default AdminProfileMenu;
